import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import VPNService from './components/VPNService';
import Features from './components/Features';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from '../../components/feature/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <VPNService />
      <Features />
      <Contact />
      <Footer />
    </div>
  );
}
